// Login.tsx
import { useState } from 'react'
import { Box, Button, TextField, Typography, Paper } from '@mui/material'
import { getSupabase } from './supabaseClient'
import { InfoOutline } from '@mui/icons-material'
import InfoPersonalDataDialog from './InfoPersonalDataDialog'
import AboutUsIcon from './AboutUsIcon'
import AboutUsDialog from './AboutUsDialog'
import AboutUsIcon_NEW from './AboutUsIcon_NEW'
import AboutUsGuy from './Icons/AboutUsGuy'
const supabase = getSupabase()
export default function Login() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [infoOpen, setInfoOpen] = useState(false)
  const [aboutUsOpen, setAboutUsOpen] = useState(false)

  const handleLogin = async () => {
    setLoading(true)
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: process.env.REACT_APP_REDIRECT_URL //"http://192.168.1.230:3000/auth/callback"//`${window.location.origin}/auth/callback`//
      }
    })
    setLoading(false)
    if (error) setMessage(error.message)
    else setMessage('Länken har skickats till din inkorg ✨')
  }

  return (
    <Box
      sx={{
        minHeight: '90dvh',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        p: 2
      }}
    >

      <Typography variant="h4" style={{ color: '#2e1929' }}>Vad handlas ska?</Typography>

      <DemoPlayer />


      <Box sx={{ position: 'relative', mt: 2 }}>
        <Box
          sx={{
            position: 'absolute',
            left: 277,
            top: -44,
            zIndex: 2,
            pointerEvents: 'auto',
          }}
        >
          {/* <AboutUsGuy frame={2} /> */}
          <AboutUsIcon_NEW callback={() => setAboutUsOpen(true)} still={false} />
        </Box>
        <Paper
          sx={{
            p: 2.5,
            width: '100%',
            maxWidth: 300,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 10,
            marginTop: 2,
            gap: message ? 1.3 : 2,
          }}
          elevation={3}
        >
          <Typography style={{ color: '#22131e' }} variant="h5" align="center">
            Logga in
          </Typography>

          <TextField
            label="Din mail"
            type="email"
            size='small'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />

          <Button
            variant="contained"
            style={{
              backgroundColor: '#11af73',
              borderRadius: 10,
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'Skickar...' : 'Skicka login-länk till din inkorg'}
          </Button>

          {message && (
            <Typography variant="body2" align="center" color="primary">
              {message}
            </Typography>
          )}

          <div
            style={{
              border: "dashed",
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'center',
              borderColor: '#746b6b79',
              gap: 10,
              padding: 4,
              borderRadius: 10,
              borderWidth:0.5,
              width: 240
            }}
            onClick={() => setInfoOpen(true)}
          >
            <InfoOutline style={{ color: "#555c6ba6" }}></InfoOutline>
            <Typography style={{ color: "#555c6bda" }} sx={{ lineHeight: 1.2, fontSize: 13, padding:"2px" }}>Information om lagring av personlig data</Typography>

          </div>

        </Paper>
      </Box>


      <InfoPersonalDataDialog open={infoOpen} onClose={() => setInfoOpen(false)} />
      <AboutUsDialog open={aboutUsOpen} onClose={() => setAboutUsOpen(false)} />
    </Box>
  )
}



function DemoPlayer() {
  return (
    <div
      style={{
        width: 180,
        padding: 6,
        // background: "#222",
        border: "ridge",
        borderRadius: 20,
        marginTop: 5,
      }}
    >
      <div
        style={{
          overflow: "hidden",
          border: "ridge",
          borderWidth: 6,
          borderRadius: 16,

        }}
      >
        <video
          src="/demo.mp4"
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  );
}
